import { render, staticRenderFns } from "./FolderSelect.vue?vue&type=template&id=72fa8180&scoped=true&"
import script from "./FolderSelect.vue?vue&type=script&lang=js&"
export * from "./FolderSelect.vue?vue&type=script&lang=js&"
import style0 from "./FolderSelect.vue?vue&type=style&index=0&id=72fa8180&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa8180",
  null
  
)

component.options.__file = "FolderSelect.vue"
export default component.exports